import React from 'react';

const InvolReservation = ({ num, data, handleChange }) => {
    return (
        <table
            className='table_style4 bdt mb70'
            cellPadding='0'
            cellSpacing='0'
            id='airCertInfoTbl'
            id-data={num}
        >
            <colgroup>
                <col style={{ width: '190px' }} />
                <col style={{ width: '410px' }} />
                <col style={{ width: '190px' }} />
                <col style={{ width: 'auto' }} />
            </colgroup>
            <tbody>
                <tr>
                    <th>
                        <p className='essential'>항공사 예약번호</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            style={{ width: '370px' }}
                            onChange={(e) => handleChange(num, 'air_pnr', e.target.value.replace(/[\u3131-\u318F\uAC00-\uD7A3]/g, '').toUpperCase())}
                            value={data.air_pnr}
                        />
                    </td>
                    <th>
                        <p class='essential'>티켓번호</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            style={{ width: '370px' }}
                            value={data.tkt_number}
                            onChange={(e) => handleChange(num, 'tkt_number', e.target.value.replace(/[A-Za-zㄱ-힣]/g, ''))}
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        <p className='essential'>INVOL 영향편 </p>
                    </th>
                    <td>
                        <input
                            type='text'
                            style={{ width: '370px' }}
                            value={data.org_flight}
                            onChange={(e) => handleChange(num, 'org_flight', e.target.value)}
                        />
                    </td>
                    <th>
                        <p class='essential'>변경 요청편</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            style={{ width: '370px' }}
                            value={data.new_flight}
                            onChange={(e) => handleChange(num, 'new_flight', e.target.value)}
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        <p className='essential'>티켓 수신 이메일 주소</p>
                    </th>
                    <td colSpan={3}>
                        <input
                            type='text'
                            style={{ width: '100%' }}
                            value={data.tkt_email_address}
                            onChange={(e) => handleChange(num, 'tkt_email_address', e.target.value)}
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;비고</p>
                    </th>
                    <td colSpan={3}>
                        <textarea
                            id='remark'
                            class='remarkInput'
                            value={data.freeMemo}
                            onChange={(e) => handleChange(num, 'freeMemo', e.target.value)}
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default InvolReservation;
